if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
    // 1. A CHAVE UNIVERSAL: Tenta achar o ID exato...
    let activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
    
    // ...se não achar, pega só o final do número e procura de novo!
    if (!activeMedia) {
      const idNumber = mediaId.toString().split('-').pop();
      activeMedia = this.elements.viewer.querySelector(`[data-media-id$="${idNumber}"]`);
    }

    // Se mesmo assim não existir (ex: produto sem foto), ele aborta em silêncio.
    if (!activeMedia) return;

    // 2. Limpa as outras e marca a foto certa
    this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
      element.classList.remove('is-active');
    });
    activeMedia.classList.add('is-active');

    // 3. Desliza a trilha do carrossel suavemente
    window.setTimeout(() => {
      const carrossel = this.elements.viewer.querySelector('ul');
      if (carrossel) {
        carrossel.scrollTo({
          left: activeMedia.offsetLeft,
          behavior: 'smooth'
        });
      } else {
        activeMedia.scrollIntoView({ behavior: 'smooth', inline: 'start' });
      }
    }, 100);

    // 4. Organiza as miniaturas pequenas (Aplicando a Chave Universal nelas também)
    if (this.elements.thumbnails) {
      let activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      
      if (!activeThumbnail) {
        const idNumber = mediaId.toString().split('-').pop();
        activeThumbnail = this.elements.thumbnails.querySelector(`[data-target$="${idNumber}"]`);
      }

      if (activeThumbnail) {
        this.elements.thumbnails.querySelectorAll('.is-active').forEach((el) => el.classList.remove('is-active'));
        activeThumbnail.classList.add('is-active');
        
        window.setTimeout(() => {
          const thumbCarrossel = this.elements.thumbnails.querySelector('ul');
          if (thumbCarrossel) {
            thumbCarrossel.scrollTo({
              left: activeThumbnail.offsetLeft,
              behavior: 'smooth'
            });
          }
        }, 100);
      }
    }

    if (this.playActiveMedia) {
      this.playActiveMedia(activeMedia);
    }
  }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
